/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuCurrencyDto as DigiworkMaitreDPosDtoMenuMenuCurrencyDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';

export interface GetDefaultCurrency_1$Params {
  CompanyId?: string;
}

export function getDefaultCurrency_1(http: HttpClient, rootUrl: string, params?: GetDefaultCurrency_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuMenuCurrencyDto>> {
  const rb = new RequestBuilder(rootUrl, getDefaultCurrency_1.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuMenuCurrencyDto>;
    })
  );
}

getDefaultCurrency_1.PATH = '/api/mng/Venue/getdefaultcurrency';
